// Static blog content for ECP Profili Sassari

export const BLOG_POSTS = [
  {
    slug: "come-scegliere-universita-telematica",
    title: "Come scegliere l'università telematica giusta per te",
    excerpt:
      "Pegaso, Mercatorum o San Raffaele? Una guida pratica per orientarti tra offerta formativa, costi e sbocchi professionali.",
    category: "Orientamento",
    date: "10 Ottobre 2025",
    readTime: "6 min",
    image:
      "https://images.unsplash.com/photo-1532294220147-279399e4e00f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "Scegliere l'università telematica giusta è il primo, fondamentale, passo verso la tua laurea online. Ogni ateneo ha una propria identità, un'offerta formativa specifica e modalità d'esame differenti.",
      "**Pegaso** è ideale per chi cerca la più ampia offerta formativa: dalle scienze giuridiche all'ingegneria, dall'economia alla psicologia. È l'ateneo telematico più grande d'Italia.",
      "**Mercatorum**, promossa dalle Camere di Commercio, è perfetta per chi vuole un percorso fortemente orientato al mondo dell'impresa, con master pratici e taglio professionalizzante.",
      "**San Raffaele** è la scelta giusta per chi è interessato a discipline sanitarie, psicologia, nutrizione e scienze olistiche.",
      "Presso il Polo ECP Profili di Sassari puoi parlare con un tutor che ti aiuta a confrontare i piani di studio, i costi e i tempi di laurea per individuare l'università perfetta per il tuo percorso.",
    ],
  },
  {
    slug: "vantaggi-laurea-online",
    title: "I veri vantaggi della laurea online (oltre la flessibilità)",
    excerpt:
      "Studio a tempi tuoi, tutor h24, esami in 95 sedi d'Italia e zero costi nascosti: ecco perché la telematica conviene.",
    category: "Laurea Online",
    date: "2 Ottobre 2025",
    readTime: "5 min",
    image:
      "https://images.unsplash.com/photo-1515378960530-7c0da6231fb1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "La laurea online non è più una scelta di ripiego. È, anzi, la scelta più moderna e flessibile per chi lavora, ha figli, vive lontano dalle grandi città universitarie o semplicemente vuole studiare con i propri tempi.",
      "**Studio 24/7**: le lezioni sono registrate, sempre disponibili, su qualsiasi dispositivo.",
      "**Tutor dedicato**: al Polo ECP Profili hai un tutor reale, in carne e ossa, che ti segue dall'iscrizione alla discussione della tesi.",
      "**95 sedi d'esame**: sostieni gli esami nella sede più vicina o comoda per te, in tutta Italia.",
      "**Stesso valore legale**: il titolo è identico, a tutti gli effetti, a quello di una laurea tradizionale.",
    ],
  },
  {
    slug: "certificazioni-eipass-perche-sono-importanti",
    title: "Certificazioni EIPASS: perché sono importanti per il tuo CV",
    excerpt:
      "EIPASS Informatico e Linguistico (B2/C1/C2): crediti, punteggi e accesso ai concorsi. Tutto incluso nei nostri percorsi.",
    category: "Certificazioni",
    date: "24 Settembre 2025",
    readTime: "4 min",
    image:
      "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "Le certificazioni EIPASS sono riconosciute dal MIUR e rappresentano un titolo spendibile in graduatorie scolastiche, concorsi pubblici e selezioni aziendali.",
      "**EIPASS Informatico** attesta la competenza digitale secondo standard europei (7 moduli).",
      "**EIPASS Linguistico** (livelli B2, C1, C2) certifica la conoscenza dell'inglese ed è valido come ESOL.",
      "Presso il Polo ECP Profili puoi ottenere entrambe le certificazioni in pacchetto con il tuo corso di laurea, con un risparmio significativo.",
    ],
  },
  {
    slug: "doppia-laurea-due-titoli-meno-tempo",
    title: "Doppia Laurea: due titoli in meno tempo, è possibile",
    excerpt:
      "Il programma Doppia Laurea ti permette di conseguire due titoli accademici risparmiando tempo e denaro. Ecco come funziona.",
    category: "Doppia Laurea",
    date: "12 Settembre 2025",
    readTime: "5 min",
    image:
      "https://images.unsplash.com/photo-1523580494863-6f3031224c94?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "Il programma **Doppia Laurea** è uno strumento poco conosciuto ma di enorme valore: ti permette di conseguire due titoli accademici contemporaneamente, riconoscendoti gli esami in comune.",
      "Pensato per studenti ambiziosi e professionisti che vogliono massimizzare il proprio CV con doppia specializzazione.",
      "Esempio: Economia Aziendale + Giurisprudenza, oppure Psicologia + Scienze dell'Educazione.",
      "Contattaci per scoprire le combinazioni disponibili presso Pegaso, Mercatorum e San Raffaele.",
    ],
  },
  {
    slug: "guida-rette-convenzioni",
    title: "Guida alle rette e alle convenzioni del Polo Profili",
    excerpt:
      "Quanto costa davvero una laurea online? Rate da 125€/mese, convenzioni fino al -50% e nessuna spesa nascosta.",
    category: "Costi & Iscrizione",
    date: "1 Settembre 2025",
    readTime: "5 min",
    image:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    content: [
      "Il costo dell'università telematica è spesso il primo dubbio. Trasparenza: la retta varia in base a università e corso, ma grazie alle convenzioni del Polo ECP Profili puoi risparmiare fino al 50%.",
      "**Rate mensili da 125€**: piani di pagamento dilazionati e personalizzati.",
      "**Convenzioni esclusive**: dipendenti pubblici, militari, forze dell'ordine, sanitari e aziende convenzionate.",
      "**Nessun costo nascosto**: tasse, esami e materiale didattico tutto incluso.",
      "Richiedi un preventivo gratuito personalizzato al nostro tutor.",
    ],
  },
];

export const findPost = (slug) => BLOG_POSTS.find((p) => p.slug === slug);
